import { FileInput, FileInputProps } from '@/decodo/components/atoms/FileInput';
import { File } from '@/decodo/components/atoms/FileUpload/File';

export interface FileUploadProps extends FileInputProps {
  label: React.ReactNode;
  value: File[];
  onChange: (files: File[]) => void;
  onFileRemove: (file: File, index: number) => void;
  classNames?: {
    root?: string;
    input?: FileInputProps['classNames'];
  };
}

export const FileUpload = ({
  label,
  value,
  onChange,
  onFileRemove,
  classNames,
  ...rest
}: FileUploadProps) => {
  return (
    <div className={classNames?.root}>
      <FileInput
        {...rest}
        value={value}
        classNames={classNames?.input}
        onChange={onChange}
      >
        {label}
      </FileInput>
      {value.length > 0 && (
        <ul>
          {value.map((file, i) => (
            <li key={file.name + i}>
              <File file={file} onRemove={() => onFileRemove(file, i)} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
